import { Component, Input, OnInit, OnDestroy, EventEmitter, Output } from "@angular/core";
import { UntypedFormBuilder, FormGroup, Validators } from "@angular/forms";
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";
import { Message, SpinnerService } from 'shared-components';
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { CultivosService } from "../../../../services/cultivos.service";

@Component({
    selector: 'app-prod-pd-new-edit',
    templateUrl: './new-edit.component.html'
})
export class ProdPdNewEditComponent implements OnInit, OnDestroy {
    private _paisDenominacion;
    private readonly destroy$ = new Subject<void>();
    public newEditForm;
    private _filtersDropDown;
    public showError: boolean;
    public mensajes = new Array<Message>();
    public disable = false;
    public registroEnUso = false;

    public _toDelete: any;
    public _editable: boolean;

    public deleteModal = false;
    public marcasModal = false;

    public denominaciones;

    public disabledPais: Subject<boolean> = new Subject();
    public disabledDenominacion: Subject<boolean> = new Subject();

    get editable(): boolean { return this._editable; }
    @Input() set editable(value: boolean) {
        this._editable = value;
        if (this.newEditForm) {
            if (value) {
                this.newEditForm.enable();
                this.disabledPais.next(false);
                this.disabledDenominacion.next(false);
            } else {
                this.newEditForm.disable();
                this.disabledPais.next(true);
                this.disabledDenominacion.next(true);
                this.newEditForm.patchValue(this.paisDenominacion);
            }
        }
    }
    @Input() paisDenominacion?;
    @Input() paisId;
    @Input() denominacionId;
    @Input() productorId?;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() pushMessage = new EventEmitter<string>();
    @Output() editableChanged = new EventEmitter<any>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _sessionContext: SessionContextService,
        private readonly _cultivosService: CultivosService,
        private readonly _dataProvider: DataProvider
    ) {}

    ngOnInit() {
        this.newEditForm = this._fb.group({
            pais: ['', Validators.required],
            denominacion: [{ value: '', disabled: true }],
        });

        if (this.paisDenominacion) {
            this.denominaciones = this._dataProvider.denominaciones;
            this.newEditForm.patchValue(this.paisDenominacion);
            this.newEditForm.patchValue({
                pais: this.paises.find(x => x.id === this.paisDenominacion.paisId),
                denominacion: this.denominaciones.find(x => x.id === this.paisDenominacion.denominacionId)
            });
            this.newEditForm.disable();
            this.disabledPais.next(true);
            this.disabledDenominacion.next(true);

            this.registroEnUso = this.paisDenominacion.registroEnUso;

        }

        this.newEditForm.get('pais').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((pais) => {
        if (pais) {
            this._filtersDropDown = {
            paisId: pais.id
            };

            this._spinnerService.showSpinner();
            this._cultivosService.getDenominaciones(this._filtersDropDown).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
            }).then((resp) => {
            if (resp.lista.length > 0) {
                this.denominaciones = resp.lista;
                this.disabledDenominacion.next(false);
            }
            });
        } else {
            this.denominaciones = null;
            this.disabledDenominacion.next(true);
            this.newEditForm.get('denominacion').reset();
        }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public get paises() {
        if (this._dataProvider.paises) {
            if (this._dataProvider.paises.length === 1 && this.newEditForm.get('pais').enabled) {
              this.newEditForm.get('pais').patchValue(this._dataProvider.paises[0]);
              this.newEditForm.get('pais').disable();
            }
          }
        return this._dataProvider.paises;
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get claims() {
        return this._sessionContext.sessionUser.lsClaimTypes;
      }

    public save() {
        this.checkForm();
        if (this.newEditForm.valid && !this.paisDenominacion) {
            this._paisDenominacion = {
                productorId: this.productorId,
                paisId: this.newEditForm.get('pais').value.id,
                denominacionId: this.newEditForm.get('denominacion').value.id,
            };
            this._spinnerService.showSpinner();
            this._cultivosService.createProductorPaisDenominacion(this._paisDenominacion).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then((resp) => {
                if (resp) {
                    this._editable = false;
                    this.refresh.emit(true);
                    this.newEditForm.disable({emitEvent: false});
                    this.disabledPais.next(true);
                    this.disabledDenominacion.next(true);
                    this.pushMessage.emit('global.success.itemCreated');
                } else {
                    this.showError = true;
                    this.mensajes.push({ class: 'error', message: 'global.error.noResponse'});
                }
            });
        }
    }

    public cancel() {
        if (this.paisId != null) {
            this.refresh.emit(true);
        } else {
            this.editableChanged.emit();
        }
      }

    public closeModal() {
        this.deleteModal = false;
        this._toDelete = '';
    }

    public edit(paisDenominacion) {
        this.newEditForm.enable();
        this.disabledPais.next(false);
        this.disabledDenominacion.next(false);
        this.editableChanged.emit(paisDenominacion);
    }


    public askDelete(paisDenominacion) {
        this.paisId = paisDenominacion.paisId;
        this.denominacionId = paisDenominacion.denominacionId;
        this.deleteModal = true;
    }

    public delete() {
        this._spinnerService.showSpinner();
        this._cultivosService.deleteProductorPaisDenominacion(this.productorId, this.paisId, this.denominacionId).toPromise().finally(() => {
        }).then(() => {
          this.closeModal();
          this.refresh.emit(true);
          this.pushMessage.emit('global.success.itemDeleted');
        });
    }

    private checkForm() {
        this.showError = this.newEditForm.invalid;
        if (this.showError) {
            this.pushMessage.emit('global.error.required');
        }
    }
}
